<template >
    <div class="container-fluid">
      
     <div class="modal" id="modalSaldoRitiroCliente" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg border-primary">
        
        <div class="modal-content">
          <div class="modal-header border border-warning bg-info">
            <h4 style="color:white" class="modal-title" id="staticBackdropLabel">
              <i style ="color:white" class="fas fa-money-check mr-3" aria-hidden="true"></i>
              VENDITA DEL {{ props.create_at }}</h4>          
          </div>


          <div class="modal-body">                  
            <div class="bg-light border border-success rounded-pill " >  
            <!--<div class="alert_ alert-warning_ border border-warning text-black" role="alert">-->
            <span class="alert-heading_ ">
            <strong><span class="ml-3"></span>
            <span style="color:blue" class="ml-4 mr-4">TOTALE <span style="color:green">{{ fmt1(props.total)}} €</span></span> 
            <span style="color:blue" class="mr-4" v-if = "props.discount != '0.00'">
                ABBUONO <span style="color:green">{{ fmt1(props.discount)}} €</span> </span> 
          <!--<span v-if="props.discount != '0.00'"> SCONTO CASSA  {{ total_discount }} %</span>-->
          <span style="color:blue" class="mr-1">PAGAMENTO </span>
            <span :style="{color: item.typeId == 'CRED' ? 'red' : 'blueviolet'}" class="mr-3" v-for="(item, index) in props.items" :key="index">
            {{ fmt1(item.amount) }}  {{ item.typeId }}
            </span>
          </strong>  
          </span>


           </div>
           </div>
<div class="modal-footer_">

<div class="modal-footer" v-if="notPaid > 0">

  <button type="button" @click="closeModal('close')" class="btn btn-secondary ">            
              <i style="color:yellow;font-size: 26px;"  class="fas fa-check_ mr-2" aria-hidden="true"></i>
              ANNULLA
  </button> 

  <button  ref="btn" @click="closeModal('setPayment')" type="button"  class="btn btn-primary">            
              <i style="color:yellow;font-size: 20px;"  class="fas fa-check_ mr-2" aria-hidden="true"></i>
              SALDA
  </button>            

</div>
<div class="modal-footer_" v-else>
  <button ref="btn" type="button" @click="closeModal('close')" class="btn btn-primary border-warning float-right mr-3 mb-4 ">            
              
              OK
  </button> 

</div>

 
       
</div>


</div>
</div>
</div>          
          
          

        
    
    
    </div>
    </template>
    <script>
    import fmt                        from '@/components/mixins/fmt'
    import alertBox                   from '@/components/common/AlertBox.vue';
    
    import { mapGetters }             from 'vuex';
    
        
    export default {
      props:['props'] , 
      mixins     : [fmt],
      components: { alertBox },
      
     data () {
        return {
        
       notPaid : 0,
      
        
        msg : {

            title : '',
            body  : '',
            type  : 0

          }
    
    
        }
      },

      directives: 
        {
         
        },
      computed: {
        ...mapGetters(['company','storeId']) ,
       

      },
    mounted()
    {
   
        this.props.items.forEach(item => {
          if(item.typeId == 'CRED')
          {
            this.notPaid += item.amount
          }
        });
         
    },
    
    created: function()
  {
    this.$nextTick(()  => {                  
        $('#modalSaldoRitiroCliente').modal('show')
        this.$refs.btn.focus()
            
    })  
  },

    methods : {
   
      closeModal(type)
      {

        $('#modalSaldoRitiroCliente').modal('hide')
        this.$nextTick(()  => {
          this.$emit(type)        
        })    
  
      }


}
}
    </script>
    <style scoped>

  h4 {
    font-family  : 'Roboto Condensed';
    font-size    : 20px;
  }
  span
  {
    font-family  : 'Roboto Condensed';
    font-size    : 26px;
  }
    
        .modal-content {
        -webkit-border-radius: 0px !important;
        -moz-border-radius: 25px !important;
        border-radius: 15px !important;
        -webkit-border: 0px !important;
        -moz-border: 15px !important;
        border: 0px !important;

    
      }
   
      .modal-footer 
      {  
         justify-content: space-between;  
      }
    </style>
    